const DEFAULT_UPLOAD_ERROR = "Something went wrong!";
const SENSITIVE_ERROR_PATTERN =
  /jwt|token|password|secret|authorization|bearer|api[_-]?key|credential|cookie|session/i;

/**
 * Builds the multipart FormData payload for the registration image upload step.
 * Caller must POST without forcing Content-Type so the browser sets the boundary.
 */
export function buildUploadImageFormData({ userId, acceptTerms, images }) {
  const formData = new FormData();
  formData.append("user_id", userId);
  formData.append("profile_completion_status", "uploadDocument");
  formData.append("pre_consent_for_displaying_images", acceptTerms);

  (images || []).forEach((img, index) => {
    formData.append(`more_images${index}`, img.blob, `profile_${index}.jpg`);
  });

  return formData;
}

/**
 * Prefer a short backend message when present; never surface secrets-looking text.
 */
export function getSafeUploadErrorMessage(
  error,
  fallback = DEFAULT_UPLOAD_ERROR
) {
  const message = error?.response?.data?.message;
  if (typeof message !== "string") {
    return fallback;
  }

  const trimmed = message.trim();
  if (!trimmed || trimmed.length > 300) {
    return fallback;
  }

  if (SENSITIVE_ERROR_PATTERN.test(trimmed)) {
    return fallback;
  }

  return trimmed;
}

/**
 * POST FormData to /updateuser without forcing Content-Type so the boundary is set.
 */
export function submitUploadImageRequest(httpClient, baseURL, formData) {
  return httpClient.post(`${baseURL}/updateuser`, formData);
}

export { DEFAULT_UPLOAD_ERROR };
